import { render, staticRenderFns } from "./EditableElementOptions.vue?vue&type=template&id=58bc7209&"
import script from "./EditableElementOptions.vue?vue&type=script&lang=js&"
export * from "./EditableElementOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports